__turbopack_context__.v({
  "resultsCountSection": "past-exhibitions-module-scss-module__sAgzQW__resultsCountSection",
  "sortByTitle": "past-exhibitions-module-scss-module__sAgzQW__sortByTitle",
});
